import { useTheme } from "@mui/material/styles";
import { ChevronsUp } from "lucide-react";
import {
  useEffect
} from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import {
  ScrollToTopButton,
  ScrollToTopButtonContent
} from "./ScrollToTopButton.styles";
import { useScrollAtBottom } from "../../hooks";

export function ScrollToTop(){
  const { pathname, state } = useLocation();
  const theme = useTheme();
  const { t } = useTranslation();
  const { isScrolling } = useScrollAtBottom({});

  useEffect(() => {
    // if the browser is able to handle scroll restoration
    // on its own steal control from it :D
    const canControlScrollRestoration = "scrollRestoration" in window.history;
    if (canControlScrollRestoration) {
      window.history.scrollRestoration = "manual";
    }

  
    if (state?.preserveScroll) return;

    window.scrollTo(0, 0);
  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const scrollToTop = () => {
    window.scrollTo({
      behavior: "smooth",
      top: 0
    });
    const mainContent = document.getElementById("button-main-content");
    if (mainContent) {
      mainContent.focus({ preventScroll: true }); // focus without jumping
    }
  };

  return (
    <ScrollToTopButton id="scrollToTopButton" aria-label={ t("scroll_to_top") } onClick={ scrollToTop } theme={ theme } isVisible={ isScrolling }  >
      <ScrollToTopButtonContent theme={ theme }>
        <ChevronsUp aria-hidden={ true } size={ 24 } />
      </ScrollToTopButtonContent>
    </ScrollToTopButton>
  );
}

